export default "static/media/default.f0b133b.svg"